import React from 'react'

import { DataGridConfigProvider } from '@cbgms/components/list/DataGridConfigProvider'
import useSupportEnums from '../Enums/useSupportEnums'

export const SupportDataGridConfigProvider: React.FC = ({ children }: React.PropsWithChildren<{}>) => {
  const enums = useSupportEnums()

  // eslint-disable-next-line react/jsx-no-useless-fragment
  if (!enums.data) return <>{children}</>

  return <DataGridConfigProvider valueOptionsLookupTable={enums.data}>{children}</DataGridConfigProvider>
}
